export default __webpack_public_path__ + "static/media/abd.151d2657.jpeg";